module.exports = __webpack_public_path__ + "media/images/problems/fisica-623b9badde38204c4ad18a228d4b4293.jpg";